/**
 * The type of a formatted string (Number or Currency).
 */
export var NumberType;
(function (NumberType) {
    NumberType["Number"] = "Number";
    NumberType["Currency"] = "Currency";
})(NumberType || (NumberType = {}));
//# sourceMappingURL=number-parse-options.js.map